import { render, staticRenderFns } from "./MentoringContact.vue?vue&type=template&id=18900c0c&scoped=true&"
import script from "./MentoringContact.vue?vue&type=script&lang=js&"
export * from "./MentoringContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18900c0c",
  null
  
)

export default component.exports